import { render, staticRenderFns } from "./authorLibrary.vue?vue&type=template&id=452d0b42&scoped=true&"
import script from "./authorLibrary.vue?vue&type=script&lang=js&"
export * from "./authorLibrary.vue?vue&type=script&lang=js&"
import style0 from "./authorLibrary.vue?vue&type=style&index=0&id=452d0b42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452d0b42",
  null
  
)

export default component.exports